const skillData = [
    "HTML",
    "CSS",
    "Scss",
    "Javascript",
    "React.js",
    "Node.js",
    "Graphql",
    "Mongodb",
    "Postgres",
    "Sql",
];

const hobbyData = [
    "Golang",
    "Flutter",
    "React Native",
    "Django",
    "Flask",
    "Laravel",
    "Php",
    "Vue.js",
    "Svelte",
];

const waitingSkill = [
    "Machine learning (LEARNING)",
    "Ethical hacking (LEARNING)",
    "Elixir",
    "Android with kotlin(basis finished)",
    "Rust(basis finished)",
    "Angular js(basis finished)",
];

const iconsData =[
    {
        name: "html",
        bg: "#E34F26",
    },
    {
        name: "css",
        bg: "#1572B6"
    },
    {
        name: "javascript",
        bg: "#F7DF1E"
    },
    {
        name: "react",
        bg: "#61DAFB"
    },
    {
        name: "next",
        bg: "#000000"
    },
    {
        name: "vue",
        bg: "#4FC08D"
    },
    {
        name: "flutter",
        bg: "#02569B"
    },
    {
        name: "graphql",
        bg: "#E10098"
    },
    {
        name: "mysql",
        bg: "#4479A1"
    },
    {
        name: "postgres",
        bg: "#336791"
    },
    {
        name: "nodejs",
        bg: "#339933"
    },
    {
        name: "go",
        bg: "#00ADD8"
    },
    {
        name: "django",
        bg: "#092E20"
    },
    {
        name: "flask",
        bg: "#000000"
    },
    {
        name: "laravel",
        bg: "#FF2D20",
    }

];

const black = "#040402";
const blackblue = "#202e43";
const lightblue = "#0099ff";
const cementgray = "#191919";
const darkblue = "#0443b7";


export const projectImages = [
    {
        src: "/screenshot/corona.png",
        name: "Corona count (WEB APP) React"
    },
    {
        src: "/screenshot/cms1.jpg",
        name: "Content Management System (PHP)"
    },
    {
        src: "/screenshot/cms2.jpg",
        name: "Content Management System (PHP)"
    },
    {
        src: "/screenshot/cms3.jpg",
        name: "Content Management System (PHP)"
    },
    {
        src: "/screenshot/ecommerce1.PNG",
        name: "Simple Ecommerce (React, Nodejs, Mongodb, Typescript)"
    },{
        src: "/screenshot/ecommerce2.PNG",
        name: "Simple Ecommerce (React, Nodejs, Mongodb, Typescript)"
    },{
        src: "/screenshot/ecommerce3.PNG",
        name: "Simple Ecommerce (React, Nodejs, Mongodb, Typescript)"
    },{
        src: "/screenshot/ecommerce4.PNG",
        name: "Simple Ecommerce (React, Nodejs, Mongodb, Typescript)"
    },
    {
        src: "/screenshot/ecommerce5.PNG",
        name: "Simple Ecommerce (React, Nodejs, Mongodb, Typescript)"
    },
    {
        src: "/screenshot/sms1.PNG",
        name: "Rapid Text SMS Client(Nodejs, Mysql)"
    },{
        src: "/screenshot/sms2.PNG",
        name: "Rapid Text SMS Client(Nodejs, Mysql)"
    },{
        src: "/screenshot/sms3.PNG",
        name: "Rapid Text SMS Client(Nodejs, Mysql)"
    },{
        src: "/screenshot/sms4.PNG",
        name: "Rapid Text SMS Client(Nodejs, Mysql)"
    },
    ,{
        src: "/screenshot/sms5.PNG",
        name: "Rapid Text SMS Client(Nodejs, Mysql)"
    },{
        src: "/screenshot/sms6.PNG",
        name: "Rapid Text SMS Client(Nodejs, Mysql)"
    },
    {
        src: "/screenshot/movie.jpeg",
        name: "Movie info (React native)"
    },
    {
        src: "/screenshot/movie2.jpeg",
        name: "Movie info (React native)"
    },
    {
        src: "/screenshot/pg1.jpeg",
        name: "Postgresql client (FLUTTER)"
    },
    {
        src: "/screenshot/pg2.jpeg",
        name: "Postgresql client (FLUTTER)"
    },
    {
        src: "/screenshot/pg3.jpeg",
        name: "Postgresql client (FLUTTER)"
    },
    {
        src: "/screenshot/pg4.jpeg",
        name: "Postgresql client (FLUTTER)"
    },
    {
        src: "/screenshot/pg5.jpeg",
        name: "Postgresql client (FLUTTER)"
    },
    {
        src: "/screenshot/pg6.jpeg",
        name: "Postgresql client (FLUTTER)"
    },

]

export { skillData, hobbyData, waitingSkill, iconsData, black, blackblue, lightblue, cementgray, darkblue };